import { render, staticRenderFns } from "./WorkerStatuses.vue?vue&type=template&id=2abaaf04&scoped=true&"
import script from "./WorkerStatuses.vue?vue&type=script&lang=js&"
export * from "./WorkerStatuses.vue?vue&type=script&lang=js&"
import style0 from "./WorkerStatuses.vue?vue&type=style&index=0&id=2abaaf04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abaaf04",
  null
  
)

export default component.exports